export const VERIFY_TEXT = {
  heading: 'Verify your email to continue company setup',
  subheading:
    "We've sent you an email to verify your email address. Please click the link in the email to verify",
};
